import { Component, ElementRef, Inject, Optional, ViewChild, forwardRef } from '@angular/core';
import { ControlContainer, FormBuilder, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseFpxFormComponent } from '@fpx/core';
import { ProfilePicChooserHelper, ProfilePicChooserState } from './profile-pic-chooser.helper';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IPopupScreenData } from 'src/app/common/models/popup-screen-data.model';
import { ProfilePicChooserService } from './profile-pic-chooser.service';
import { CameraService } from 'src/app/services/mobile/camera/camera.service';
import { ResponsiveService } from 'src/app/responsive.service';

@Component({
  selector: 'app-profile-pic-chooser',
  templateUrl: './profile-pic-chooser.component.html',
  styleUrls: ['./profile-pic-chooser.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProfilePicChooserComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ProfilePicChooserComponent),
      multi: true,
    },
    ProfilePicChooserHelper,ProfilePicChooserService
  ]
})
export class ProfilePicChooserComponent extends BaseFpxFormComponent<ProfilePicChooserHelper, ProfilePicChooserState> {

  @ViewChild ('cameraView') cameraView: ElementRef;
  @Inject(MAT_DIALOG_DATA) protected data: IPopupScreenData;
  popupData:any;
  IMAGE_DATA: string = "";
  toggleCamera: boolean = false;
  cameraPreviewRect: any;
 
  constructor(
    @Optional() _controlContainer: ControlContainer,
    _formBuilder: FormBuilder,
    private _router: Router,
    private _picCaptureHelper: ProfilePicChooserHelper,
    protected _responsive : ResponsiveService){
    super(_formBuilder, _router, _controlContainer, _picCaptureHelper);

  }

  // protected doPreInit(): void {
  //   this.addFormControl('docCapture','', [Validators.required], [], 'change', 1);
  // }

 ngOnInit(): void {
   this.popupData = this.IMAGE_DATA;
 }

}
